// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDAIBtC0vQPspNGGJ4fLsyTzunC7EpGkXg",
    authDomain: "yoga-planner-40ec9.firebaseapp.com",
    databaseURL: "https://yoga-planner-40ec9.firebaseio.com",
    projectId: "yoga-planner-40ec9",
    storageBucket: "yoga-planner-40ec9.appspot.com",
    messagingSenderId: "63054303341",
    appId: "1:63054303341:web:8cff6740d5ea5dda2aef64",
    measurementId: "G-YLW6T5MZPH"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
